import React from 'react';
import { useVersionInfo } from '../hooks/useVersionInfo';

const Footer: React.FC = () => {
  const { version, releaseDate } = useVersionInfo();
  return (
    <footer
      style={{
        position: 'fixed',
        left: 0,
        bottom: 0,
        width: '100%',
        background: 'rgba(255,255,255,0.95)',
        color: '#6c757d',
        textAlign: 'center',
        fontSize: '0.9em',
        padding: '0.5em 0',
        zIndex: 100
      }}
      className="footer-version-info"
    >
      &copy; 2025 Kiebitz &mdash; Version {version} &mdash; Released {releaseDate}
    </footer>
  );
};

export default Footer;
